// extracted by mini-css-extract-plugin
export default {"overlay_wrapper":"dashboard_overlay_wrapper__d8ed5","breadscrums_wrapper":"dashboard_breadscrums_wrapper__td0PQ"};